export const orderStatuses = {
  1: "warning", // open
  2: "success", // confirmed
  3: "info", // assigned
  4: "info", // in progress
  5: "info", // reported
  6: "default", // cancelled
};
